import styled, { css } from 'styled-components';
import { palette } from '../../theme/colors';

type SContainerFixedProps = {
  $position: 'level-0' | 'level-1' | 'level-2';
  $scrollableBackground: boolean;
};

type SBaseProps = {
  type?: 'yellow' | 'red';
  disabled?: boolean;
};

function fixedFloatBottom(p: SContainerFixedProps): string {
  if (p.$scrollableBackground) {
    if (p.$position === 'level-0') return '3.125rem';
    if (p.$position === 'level-1') return '6.688rem';
    if (p.$position === 'level-2') return 'calc(6.688rem + 45px + 1rem)';
  }
  if (p.$position === 'level-0') return '0';
  if (p.$position === 'level-1') return '4.86rem';
  if (p.$position === 'level-2') return 'calc(4.86rem + 45px + 1rem)';
  return '0';
}

function fixedFloatHeight(p: SContainerFixedProps): string {
  return p.$scrollableBackground ? 'auto' : '5rem';
}

const flexCenter = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

/** Default: fixed to viewport (tabs / bottom inset). */
export const SContainerFixed = styled.div<SContainerFixedProps>`
  position: fixed;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: ${p => fixedFloatBottom(p)};
  height: ${p => fixedFloatHeight(p)};
  width: 100%;
  z-index: 5;
  max-width: 26rem;
  padding-bottom: ${p => (p.$scrollableBackground ? '0' : '10px')};
  ${flexCenter}
`;

/** Inside a parent that supplies position (e.g. sidebar footer above banner). */
export const SContainerInline = styled.div`
  position: relative;
  left: auto;
  bottom: auto;
  transform: none;
  width: 100%;
  max-width: none;
  z-index: auto;
  height: auto;
  padding-bottom: 0;
  ${flexCenter}
`;

export const SBase = styled.div<SBaseProps>`
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1.4rem;
  height: 45px;
  width: 90%;
  max-width: 22rem;
  border: none;

  font-size: 1rem;
  font-family: 'Roboto-Medium';
  font-weight: 500;

  background-color: ${palette.honeyYellow};
  color: ${palette.black};
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  opacity: ${props => (props.disabled ? 0.5 : 1)};

  ${props =>
    props.color === 'red' &&
    css`
      background-color: ${palette.tartOrange};
      color: ${palette.white};
    `}

  ${props =>
    props.color === 'blue-outlined' &&
    css`
      background-color: ${palette.navyBlue};
      color: ${palette.white};
      border: 1px solid ${palette.honeyYellow};
    `}
`;
